// TODO: This doesn't need to be an HOC, it would work fine as a regular
//       React component.
import React, { Component, ComponentType } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { fromJS, Map, List } from 'immutable';

// COMPONENTS
import FlashMessage from 'components/FlashMessage';
import ApiErrors from 'components/ApiErrors';

// CONSTANTS
import { FLASH_MESSAGE_TYPES } from 'constants/common';

// Types
interface NotificationConfig {
  selectNotifications: () => (state: any) => List<any>;
  selectErrors: () => (state: any) => Map<string, any>;
  clearNotifications: () => any;
}

interface InjectedNotificationProps {
  notifications: List<any>;
  errors: Map<string, any>;
  clearNotifications: () => void;
}

interface NotificationState {
  flashMessageVisible: boolean;
  flashMessageType: FLASH_MESSAGE_TYPES | null;
  flashMessage: string | React.ReactElement | null;
  timeout: number;
  stashedProps: {
    notifications: List<any>;
    errors: Map<string, any>;
  };
}

type WrappedComponentPropsWithIntl = InjectedNotificationProps & WrappedComponentProps;

const withNotifications = <P extends object>(UnwrappedComponent: ComponentType<P>, config: NotificationConfig) => {
  class WrappedComponent extends Component<WrappedComponentPropsWithIntl & P, NotificationState> {
    state: NotificationState = {
      flashMessageVisible: false,
      flashMessageType: null,
      flashMessage: null,
      timeout: 1000,
      stashedProps: {
        notifications: fromJS([]),
        errors: fromJS({}),
      },
    };

    static getDerivedStateFromProps(
      nextProps: WrappedComponentPropsWithIntl,
      prevState: NotificationState
    ): Partial<NotificationState> | null {
      let nextState: Partial<NotificationState> = {
        stashedProps: {
          errors: nextProps.errors,
          notifications: nextProps.notifications,
        },
      };

      const { errors } = nextProps;

      if (prevState.stashedProps.notifications !== nextProps.notifications && nextProps.notifications.size) {
        const flashMessage = nextProps.intl.formatMessage(
          {
            id: nextProps.notifications.getIn([0, 'translationId']) as string,
          },
          {}
        );

        nextState = {
          ...nextState,
          flashMessageVisible: true,
          flashMessageType: FLASH_MESSAGE_TYPES.success,
          timeout: 1000,
          flashMessage,
        };
      }

      if (errors.size) {
        const flashMessage = errors.get('message') ? (
          nextProps.intl.formatMessage({
            id: errors.getIn(['message', 'translationId']) as string,
          })
        ) : (
          // @ts-expect-error TS(2786): 'ApiErrors' cannot be used as a JSX component.
          <ApiErrors errors={nextProps.errors.toJS()} />
        );

        nextState = {
          ...nextState,
          flashMessageVisible: true,
          flashMessageType: FLASH_MESSAGE_TYPES.error,
          timeout: 10000,
          flashMessage,
        };
      }

      return nextState;
    }

    handleCloseFlashMessage = (): void => {
      this.setState({
        flashMessageVisible: false,
        flashMessageType: null,
        flashMessage: null,
      });
      this.props.clearNotifications();
    };

    render() {
      return [
        <UnwrappedComponent key="0" {...this.props} />,
        <FlashMessage
          key="1"
          visible={this.state.flashMessageVisible}
          type={this.state.flashMessageType}
          text={this.state.flashMessage}
          onClose={this.handleCloseFlashMessage}
          timeout={this.state.timeout}
        />,
      ];
    }
  }

  const { selectNotifications, selectErrors, clearNotifications } = config;

  const mapStateToProps = createStructuredSelector({
    notifications: selectNotifications(),
    errors: selectErrors(),
  });

  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        clearNotifications,
      },
      dispatch
    );

  // @ts-expect-error TS(2769): No overload matches this call.
  return connect(mapStateToProps, mapDispatchToProps)(injectIntl(WrappedComponent));
};

export default withNotifications;
